document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("engravingModal");
  const modalBtns = document.querySelectorAll(".engraving_link");
  const modalCloseBtn = document.querySelector(".engraving-options_container .close");

  if (modal) {
    modalBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        modal.style.display = "block";
      });
    });

    if (modalCloseBtn) {
      modalCloseBtn.addEventListener("click", () => {
        modal.style.display = "none";
      });
    }

    window.addEventListener("click", (event) => {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    });
  }
});

document.addEventListener("click", function (e) {
  if (e.target?.closest(".engraving_option-values p")) {
    const selected = e.target;
    const container = selected.closest('.engraving_option-values');
    container.querySelectorAll('p').forEach(p => p.classList.remove('active'));
    selected.classList.add('active');

    const dataValue = selected.getAttribute('data-value');
    const selectedVal = selected.getAttribute('data-position');

    if (dataValue === 'select') {
      document.querySelectorAll('.engraving-fields').forEach(field => {
        const inputs = field.querySelectorAll('input');
        const isEmpty = Array.from(inputs).every(input => input.value.trim() === '');
        if (isEmpty) {
          field.classList.add('hide');
          field.classList.remove('active');
        }
      });

      const targetBlock = document.querySelector(`#engravingModal [data-value="${selectedVal}"]`);
      if (targetBlock) {
        targetBlock.querySelectorAll('.engraving_option-values p').forEach(p => p.classList.remove('active'));
        const selectedP = targetBlock.querySelector(`.engraving_option-values p[data-value="${dataValue}"]`);
        if (selectedP) selectedP.classList.add('active');

        const fields = targetBlock.querySelector('.engraving-fields');
        if (fields) {
          fields.classList.remove('hide');
          fields.classList.add('active');
        }

        const activeFont = targetBlock.querySelector('.engraving-fonts-list p.active');
        if (activeFont) {
          const dataFont = activeFont.getAttribute('data-font');
          document.querySelectorAll('.engraving-font--preview img').forEach(img => img.classList.add('hide'));
          const targetImg = document.querySelector(`.engraving-font--preview img[alt="${dataFont}"]`);
          if (targetImg) targetImg.classList.remove('hide');
        }
        
        updateTextPreview();

        if (e.target.closest('#engravingModal')) {
          syncPDPOptions(selectedVal, dataValue);
        }
      }
      
      if (e.target.closest('#engravingModal')) {
        syncPDPOptions(selectedVal, dataValue);
      }
    } else if (dataValue === 'none') {
      console.log("The None value has been selected");
      const parentContainer = selected.closest('.engraving_option[data-value]');
      const position = parentContainer ? parentContainer.getAttribute('data-value') : null;
      if (position) {
        const targetBlock = document.querySelector(`#engravingModal [data-value="${position}"]`);
        if (targetBlock) {
          const fields = targetBlock.querySelector('.engraving-fields');
          if (fields) {
            fields.classList.add('hide');
            fields.classList.remove('active');
          }
        }
      }
      
      if (e.target.closest('#engravingModal')) {
        syncPDPOptions(position, dataValue);
      }
      
      updateTextPreview();
      updateAddToCartButton();
    }
  }
});

function updateAddToCartButton() {
  const isChecked = document.getElementById('termsCheckbox')?.checked;
  let hasSelectedEngraving = false;
  let hasRequiredText = true;
  
  const faceOption = document.querySelector('#engravingModal .engraving_option1 .engraving_option-values p[data-value="select"].active');
  if (faceOption) {
    hasSelectedEngraving = true;
    const faceTextField = document.querySelector('.front-engraving-fields .engraving-text');
    const face8Field = document.querySelector('#face-engraving-8-input');
    
    let faceTextFilled = false;
    if (faceTextField) {
      faceTextFilled = faceTextField.value.trim().length > 0;
    } else if (face8Field) {
      faceTextFilled = face8Field.textContent.replace(/\n/g, '').trim().length > 0;
    }
    
    if (!faceTextFilled) {
      hasRequiredText = false;
    }
  }
  
  const insideOption = document.querySelector('#engravingModal .engraving_option2 .engraving_option-values p[data-value="select"].active');
  if (insideOption) {
    hasSelectedEngraving = true;
    const insideTextField = document.querySelector('.inside-engraving-fields .engraving-text');
    const insideTextFilled = insideTextField && insideTextField.value.trim().length > 0;
    
    if (!insideTextFilled) {
      hasRequiredText = false;
    }
  }
  
  const shouldEnable = hasSelectedEngraving ? 
    (hasRequiredText && isChecked) : 
    isChecked;
  
  document.querySelector('.engraving-addtocart').disabled = !shouldEnable;
}

document.addEventListener("input", function (e) {
  if (e.target?.classList.contains("engraving-text")) {
    e.target.classList.toggle("has-content", e.target.value.trim() !== "");
    updateAddToCartButton();
    updateTextPreview();
  }
});

document.addEventListener("input", function (e) {
  if (e.target?.classList.contains("engraving-text")) {
    e.target.classList.toggle("has-content", e.target.value.trim() !== "");
    updateAddToCartButton();
    updateTextPreview(e.target);
  }
});

function updateTextPreview(targetInput = null) {
  const faceField = document.querySelector('.front-engraving-fields');
  if (faceField) {
    const faceTextInput = faceField.querySelector('.engraving-text') || faceField.querySelector('#face-engraving-8-input');
    const faceActiveFont = faceField.querySelector('.engraving-fonts-list p.active');
    const facePreviewElement = document.querySelector('.preview-text[data-preview-type="face"]');
    
    if (faceTextInput && faceActiveFont && facePreviewElement) {
      let text = '';
      if (faceTextInput.id === 'face-engraving-8-input') {
        text = faceTextInput.textContent.replace(/\n/g, ' ').trim();
      } else {
        text = faceTextInput.value.trim();
      }
      const fontFamily = faceActiveFont.getAttribute('data-font');
      
      facePreviewElement.textContent = text || 'Enter face text to see preview';
      facePreviewElement.setAttribute('data-font-family', fontFamily);
    }
  }
  
  const insideField = document.querySelector('.inside-engraving-fields');
  if (insideField) {
    const insideTextInput = insideField.querySelector('.engraving-text');
    const insideActiveFont = insideField.querySelector('.engraving-fonts-list p.active');
    const insidePreviewElement = document.querySelector('.preview-text[data-preview-type="inside"]');
    
    if (insideTextInput && insideActiveFont && insidePreviewElement) {
      const text = insideTextInput.value.trim();
      const fontFamily = insideActiveFont.getAttribute('data-font');
      
      insidePreviewElement.textContent = text || 'Enter inside text to see preview';
      insidePreviewElement.setAttribute('data-font-family', fontFamily);
    }
  }
}

function syncPDPOptions(position, value) {
  const pdpContainer = document.querySelector('.engraving-options_container');
  if (!pdpContainer || !position) return;
  
  let targetOption;
  if (position === 'front') {
    targetOption = pdpContainer.querySelector('.engraving_option1');
  } else if (position === 'inside') {
    targetOption = pdpContainer.querySelector('.engraving_option2');
  }
  
  if (targetOption) {
    const options = targetOption.querySelectorAll('.engraving_option-values p');
    options.forEach(option => option.classList.remove('active'));
    
    const targetPDP = targetOption.querySelector(`p[data-value="${value}"]`);
    if (targetPDP) {
      targetPDP.classList.add('active');
    }
  }
}

document.addEventListener('click', function (e) {
  if (e.target?.closest('.engraving-fonts-list p')) {
    const selected = e.target;
    const container = selected.closest('.engraving-fonts-list');
    container.querySelectorAll('p').forEach(p => p.classList.remove('active'));
    selected.classList.add('active');

    const dataFont = selected.getAttribute('data-font');
    const readonlyInput = selected.closest('.engraving-fields').querySelector('input[readonly]');
    if (readonlyInput) {
      readonlyInput.style.fontFamily = dataFont;
    }

    document.querySelectorAll('.engraving-font--preview img').forEach(img => img.classList.add('hide'));
    const imgToShow = document.querySelector(`.engraving-font--preview img[alt="${dataFont}"]`);
    if (imgToShow) imgToShow.classList.remove('hide');

    updateTextPreview();
  }
});

function addItem(qty, id, properties, callback) {
  const params = new URLSearchParams();
  params.append("quantity", qty);
  params.append("id", id);
  if (properties) {
    for (const key in properties) {
      params.append(`properties[${key}]`, properties[key]);
    }
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: params.toString()
  })
  .then(response => response.json())
  .then(() => {
    document.querySelector('.button.add-to-cart-button')?.click();
    document.getElementById('engravingModal').style.display = 'none';
  })
  .catch(console.error);
}

document.addEventListener('click', function (e) {
  if (e.target?.classList.contains('engraving-addtocart')) {
    const btn = e.target;
    const qty = 1;
    const id = btn.getAttribute('data-product');
    const parent_product = btn.getAttribute('data-product-title');
    const parent_id = btn.getAttribute('data-mainproduct-id');
    const timestamp = Date.now();

    const faceText = document.querySelector('.engraving-fields.front-engraving-fields .engraving-text')?.value;
    const faceFont = document.querySelector('.engraving-fields.front-engraving-fields .engraving-fonts-list p.active')?.textContent;
    const faceName = document.querySelector('.engraving-fields.front-engraving-fields .engraving-text')?.getAttribute('name');

    const insideText = document.querySelector('.engraving-fields.inside-engraving-fields .engraving-text')?.value;
    const insideFont = document.querySelector('.engraving-fields.inside-engraving-fields .engraving-fonts-list p.active')?.textContent;
    const insideName = document.querySelector('.engraving-fields.inside-engraving-fields .engraving-text')?.getAttribute('name');

    const properties = {
      "Product": parent_product,
      "_endravingid": id,
      "_mainproductid": parent_id,
      "_timestamp": timestamp
    };

    if (faceText && faceFont && faceName) {
      properties["Face Engraving"] = faceName;
      properties["Face Font"] = faceFont;
      properties["Face Engraving text"] = faceText;
    }
    if (insideText && insideFont && insideName) {
      properties["Inside Engraving"] = insideName;
      properties["Inside Font"] = insideFont;
      properties["Inside Engraving text"] = insideText;
    }

    addItem(qty, id, properties);
  }
});

document.addEventListener("change", function (e) {
  if (e.target?.classList.contains("main-product_variants-mobile")) {
    const val = e.target.value;
    document.querySelector('.sticky-add-to-cart').disabled = false;
    document.querySelectorAll('.main-product_variants .single-variant-option').forEach(el => el.classList.remove('active'));
    const activeVariant = document.querySelector(`.main-product_variants .single-variant-option[data-variant="${val}"]`);
    if (activeVariant) activeVariant.classList.add('active');
  }
});

document.addEventListener("change", function (e) {
  if (e.target?.id === "termsCheckbox") {
    updateAddToCartButton();
  }
});